<template>
  <div>
    <v-toolbar flat color="white">
      <v-toolbar-title>Zimmet Yönetimi</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-text-field
        v-model="search"
        append-icon="search"
        label="Ara (kullanıcı / ürün / seri)"
        single-line
        hide-details
        clearable
        style="max-width: 320px"
      ></v-text-field>
      <v-btn color="primary" dark class="ml-3" @click="openAssign">
        <v-icon left>assignment_ind</v-icon>
        Zimmetle
      </v-btn>
    </v-toolbar>

    <v-data-table
      :headers="headers"
      :items="filteredLines"
      :loading="loading"
      :rows-per-page-items="[50, 100, 500, { text: 'Tümü', value: -1 }]"
      class="elevation-1"
    >
      <template v-slot:items="props">
        <td class="px-2">{{ fullName(props.item) }}</td>
        <td class="px-2">
          <v-chip small :color="typeColor(props.item.inventoryType)" text-color="white">
            {{ props.item.inventoryTypeName }}
          </v-chip>
        </td>
        <td class="px-2">{{ props.item.productName }}{{ variantSuffix(props.item) }}</td>
        <td class="px-2">{{ props.item.weight }}</td>
        <td class="px-2">{{ props.item.purityLabel }}</td>
        <td class="px-2">{{ props.item.size || '-' }}</td>
        <td class="px-2">{{ props.item.serialNumber || '-' }}</td>
        <td class="px-2 text-xs-right">{{ props.item.quantity }}</td>
        <td class="px-2">
          <v-btn small flat color="red darken-1" @click="openReturn(props.item)">
            <v-icon small left>undo</v-icon>
            Geri Al
          </v-btn>
        </td>
      </template>
      <template v-slot:no-data>
        <div class="text-xs-center pa-4 grey--text">Henüz zimmetli ürün yok.</div>
      </template>
    </v-data-table>

    <!-- ========== ZİMMETLE DIALOG ========== -->
    <v-dialog v-model="assignDialog" max-width="560" persistent>
      <v-card>
        <v-card-title class="headline primary white--text">
          <v-icon left color="white">assignment_ind</v-icon>
          Zimmetle
        </v-card-title>
        <v-card-text class="pa-4">
          <v-select
            v-model="assignForm.userId"
            :items="users"
            item-text="label"
            item-value="id"
            label="Kullanıcı"
          ></v-select>

          <v-tabs v-model="assignTab" grow class="mb-2">
            <v-tab>Ziynet / Külçe</v-tab>
            <v-tab>Takı</v-tab>
          </v-tabs>

          <!-- Ziynet/Külçe -->
          <div v-if="assignTab === 0">
            <v-select
              v-model="assignForm.inventoryItemId"
              :items="ziynetKulceItems"
              item-text="label"
              item-value="id"
              label="Ürün (Ziynet/Külçe)"
            ></v-select>
            <div v-if="selectedInventoryItem" class="caption grey--text mb-2">
              Ana envanterde boşta: <strong>{{ availableOf(selectedInventoryItem) }}</strong> adet
              (Toplam {{ selectedInventoryItem.quantity }})
            </div>
            <v-text-field
              v-model.number="assignForm.quantity"
              label="Adet"
              type="number"
              min="1"
            ></v-text-field>
          </div>

          <!-- Takı -->
          <div v-else>
            <v-text-field
              v-model="assignForm.barcode"
              label="Takı Barkodu / Seri No"
              prepend-icon="qr_code_scanner"
              hint="Sertifikadaki barkodu okutun veya yazın"
              persistent-hint
              autofocus
              @keyup.enter="saveAssign"
            ></v-text-field>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn flat @click="assignDialog = false">İptal</v-btn>
          <v-btn color="primary" dark :loading="assignSaving" @click="saveAssign">Zimmetle</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- ========== GERİ AL DIALOG (ziynet/külçe adet) ========== -->
    <v-dialog v-model="returnDialog" max-width="460" persistent>
      <v-card>
        <v-card-title class="headline red darken-1 white--text">
          <v-icon left color="white">undo</v-icon>
          Ana Envantere Geri Al
        </v-card-title>
        <v-card-text class="pa-4">
          <div class="mb-2">
            <strong>{{ fullName(returnTarget) }}</strong> →
            {{ returnTarget && returnTarget.productName }}{{ variantSuffix(returnTarget) }}
          </div>
          <v-text-field
            v-model.number="returnQuantity"
            label="Geri alınacak adet"
            type="number"
            min="1"
            :max="returnTarget ? returnTarget.quantity : 1"
          ></v-text-field>
          <div class="caption grey--text">
            Kullanıcıda zimmetli: {{ returnTarget ? returnTarget.quantity : 0 }} adet
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn flat @click="returnDialog = false">İptal</v-btn>
          <v-btn color="red darken-1" dark :loading="returnSaving" @click="confirmReturn">Geri Al</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { userService } from "@/_services";

export default {
  data: () => ({
    loading: false,
    lines: [],
    users: [],
    inventoryItems: [],
    search: "",
    headers: [
      { text: "Kullanıcı", value: "userName" },
      { text: "Tip", value: "inventoryTypeName" },
      { text: "Ürün", value: "productName" },
      { text: "Ağırlık", value: "weight" },
      { text: "Ayar", value: "purityLabel" },
      { text: "Ölçü", value: "size" },
      { text: "Seri No", value: "serialNumber" },
      { text: "Adet", value: "quantity", align: "right" },
      { text: "", value: "actions", sortable: false },
    ],

    assignDialog: false,
    assignSaving: false,
    assignTab: 0,
    assignForm: { userId: null, inventoryItemId: null, quantity: 1, barcode: "" },

    returnDialog: false,
    returnSaving: false,
    returnTarget: null,
    returnQuantity: 1,
  }),

  computed: {
    ziynetKulceItems() {
      return this.inventoryItems
        .filter(i => i.inventoryType !== 0) // 0 = Takı
        .map(i => ({
          ...i,
          label: `${i.inventoryTypeName} - ${i.productName}${this.variantSuffix(i)} (${i.weight} gr, ${i.purityLabel}) — boşta ${this.availableOf(i)}`,
        }));
    },
    selectedInventoryItem() {
      return this.inventoryItems.find(i => i.id === this.assignForm.inventoryItemId) || null;
    },
    filteredLines() {
      const q = (this.search || "").toLocaleLowerCase("tr");
      if (!q) return this.lines;
      return this.lines.filter(l =>
        [this.fullName(l), l.userName, l.productName, l.serialNumber, l.inventoryTypeName]
          .filter(Boolean)
          .some(v => v.toLocaleLowerCase("tr").includes(q))
      );
    },
  },

  created() {
    this.loadAll();
  },

  methods: {
    fullName(l) {
      if (!l) return "";
      const n = [l.firstName, l.lastName].filter(Boolean).join(" ").trim();
      return n || l.userName || `#${l.userId}`;
    },
    // Ziynet varyantı: Kulp (Kulplu/Kulpsuz) + Tarih (Yeni/Eski). Boşsa boş döner.
    variantSuffix(i) {
      if (!i) return "";
      const parts = [i.kulp, i.dateType].filter(Boolean);
      return parts.length ? ` [${parts.join(" / ")}]` : "";
    },
    typeColor(t) {
      if (t === 0) return "teal";
      if (t === 1) return "amber darken-2";
      return "blue-grey darken-1";
    },
    // Ana envanterde boşta = toplam - (bu üründen tüm kullanıcılara zimmetli)
    availableOf(item) {
      if (!item) return 0;
      const assigned = this.lines
        .filter(l => l.inventoryItemId === item.id)
        .reduce((s, l) => s + (l.quantity || 0), 0);
      return item.quantity - assigned;
    },

    async loadAll() {
      this.loading = true;
      try {
        const [linesRes, itemsRes, usersRes] = await Promise.all([
          this.$store.dispatch("inventory/getAllZimmets"),
          this.$store.dispatch("inventory/getInventoryItems"),
          userService.getAll(),
        ]);
        this.lines = linesRes || [];
        this.inventoryItems = itemsRes || [];
        this.users = (usersRes || []).map(u => ({
          ...u,
          label: [u.firstName, u.lastName].filter(Boolean).join(" ").trim()
            ? `${[u.firstName, u.lastName].filter(Boolean).join(" ")} (${u.username})`
            : u.username,
        }));
      } catch (e) {
        this.notify("Zimmet verileri yüklenemedi: " + this.errMsg(e));
      } finally {
        this.loading = false;
      }
    },

    openAssign() {
      this.assignForm = { userId: null, inventoryItemId: null, quantity: 1, barcode: "" };
      this.assignTab = 0;
      this.assignDialog = true;
    },

    async saveAssign() {
      if (!this.assignForm.userId) {
        this.notify("Lütfen kullanıcı seçin.");
        return;
      }
      let dto;
      if (this.assignTab === 1) {
        const code = (this.assignForm.barcode || "").trim().replace(/\*/g, "-"); // okuyucu "-"yi "*" gönderebilir
        if (!code) { this.notify("Takı barkodu okutun."); return; }
        dto = { userId: this.assignForm.userId, barcode: code };
      } else {
        if (!this.assignForm.inventoryItemId) { this.notify("Ürün seçin."); return; }
        if (!this.assignForm.quantity || this.assignForm.quantity <= 0) { this.notify("Adet 0'dan büyük olmalı."); return; }
        dto = {
          userId: this.assignForm.userId,
          inventoryItemId: this.assignForm.inventoryItemId,
          quantity: this.assignForm.quantity,
        };
      }
      this.assignSaving = true;
      try {
        const res = await this.$store.dispatch("inventory/zimmetAssign", dto);
        if (res && res.success === false) { this.notify(res.message); return; }
        // Takı modunda barkod alanını temizleyip açık tut (seri okutmaya devam)
        if (this.assignTab === 1) {
          this.assignForm.barcode = "";
        } else {
          this.assignDialog = false;
        }
        this.notify((res && res.message) || "Zimmetlendi.");
        await this.loadAll();
      } catch (e) {
        this.notify("Hata: " + this.errMsg(e));
      } finally {
        this.assignSaving = false;
      }
    },

    openReturn(line) {
      this.returnTarget = line;
      // Takı: tek tıkla geri al (seri bazında, adet=1)
      if (line.inventoryType === 0) {
        this.doReturnTaki(line);
        return;
      }
      this.returnQuantity = line.quantity;
      this.returnDialog = true;
    },

    async doReturnTaki(line) {
      this.returnSaving = true;
      try {
        const res = await this.$store.dispatch("inventory/zimmetReturn", { barcode: line.serialNumber });
        if (res && res.success === false) { this.notify(res.message); return; }
        this.notify((res && res.message) || "Ana envantere geri alındı.");
        await this.loadAll();
      } catch (e) {
        this.notify("Hata: " + this.errMsg(e));
      } finally {
        this.returnSaving = false;
      }
    },

    async confirmReturn() {
      if (!this.returnTarget) return;
      if (!this.returnQuantity || this.returnQuantity <= 0) { this.notify("Adet 0'dan büyük olmalı."); return; }
      this.returnSaving = true;
      try {
        const res = await this.$store.dispatch("inventory/zimmetReturn", {
          userId: this.returnTarget.userId,
          inventoryItemId: this.returnTarget.inventoryItemId,
          quantity: this.returnQuantity,
        });
        if (res && res.success === false) { this.notify(res.message); return; }
        this.returnDialog = false;
        this.notify((res && res.message) || "Ana envantere geri alındı.");
        await this.loadAll();
      } catch (e) {
        this.notify("Hata: " + this.errMsg(e));
      } finally {
        this.returnSaving = false;
      }
    },

    errMsg(e) {
      return (e && e.response && e.response.data && e.response.data.message) || (e && e.message) || "Bilinmeyen hata";
    },
    notify(msg) {
      this.$store.state.dialog = true;
      this.$store.state.message = msg;
    },
  },
};
</script>
